<div
    class="tw-bg-[#FBFBFB] tw-p-[50px] tw-rounded-xl tw-shadow-lg tw-max-h-[95vh] tw-overflow-y-auto tw-relative"
>
    <mat-icon
        [mat-dialog-close]="true"
        class="tw-text-gray-500 tw-cursor-pointer tw-absolute tw-right-[30px] tw-top-[30px]"
        >close</mat-icon
    >
    <!-- Header -->
    <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
        <h2 class="tw-text-lg md:tw-text-xl !tw-font-bold tw-text-[#024B3F]">
            {{ translations[selectedLanguage].header }}
        </h2>
    </div>

    <!-- Intro Text -->
    <p class="tw-text-sm tw-text-gray-600 tw-mb-4">
        {{ translations[selectedLanguage].intro }}
    </p>
    <ul
        class="tw-text-sm tw-text-gray-600 tw-mb-4 tw-ml-6 tw-list-disc tw-flex tw-flex-col tw-gap-2 default-html"
    >
        <li
            [innerHTML]="translations[selectedLanguage].points.improvement"
        ></li>
        <li [innerHTML]="translations[selectedLanguage].points.content"></li>
        <li [innerHTML]="translations[selectedLanguage].points.experience"></li>
    </ul>
    <p class="tw-text-sm tw-text-gray-600 tw-mb-4">
        {{ translations[selectedLanguage].thankYou }}
    </p>

    <!-- Feedback Form -->
    <form
        class="tw-space-y-4"
        [formGroup]="form"
        (ngSubmit)="submitForm()"
        #formContainer
    >
        <!-- Name -->
        <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-mb-1">
                {{ translations[selectedLanguage].name }}
                <span class="tw-text-red-500">*</span>
            </label>
            <input
                type="text"
                formControlName="name"
                class="tw-w-full tw-border tw-rounded-lg tw-px-3 tw-py-2 focus:tw-ring-1 focus:tw-ring-gray-600 focus:tw-outline-none"
                [placeholder]="translations[selectedLanguage].name"
            />
            <!-- Validation errors (name) -->
            <div
                class="error tw-flex tw-items-start tw-mt-1"
                *ngIf="form.get('name')?.touched && form.get('name')?.invalid"
            >
                <mat-icon
                    fontSet="material-icons-outlined"
                    class="tw-text-red-500 tw-text-sm error-icon !tw-h-5 !tw-w-5 !tw-min-h-[20px] !tw-min-w-[20px]"
                    >info</mat-icon
                >
                <span
                    *ngIf="form.get('name')?.errors?.['required']"
                    class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
                >
                    {{ translations[selectedLanguage].error.required.name }}
                </span>
                <span
                    *ngIf="form.get('name')?.errors?.['pattern'] || form.get('name')?.errors?.['minlength'] || form.get('name')?.errors?.['maxlength']"
                    class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
                >
                    {{ translations[selectedLanguage].error.pattern.name }}
                </span>
            </div>
        </div>

        <!-- Email -->
        <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-mb-1">
                {{ translations[selectedLanguage].email }}
                <span class="tw-text-red-500">*</span>
            </label>
            <input
                type="email"
                formControlName="email"
                class="tw-w-full tw-border tw-rounded-lg tw-px-3 tw-py-2 focus:tw-ring-1 focus:tw-ring-gray-600 focus:tw-outline-none"
                placeholder="e.g., example@email.com"
            />
            <!-- Validation errors (email) -->
            <div
                class="error tw-flex tw-items-start tw-mt-1"
                *ngIf="form.get('email')?.touched && form.get('email')?.invalid"
            >
                <mat-icon
                    fontSet="material-icons-outlined"
                    class="tw-text-red-500 tw-text-sm error-icon !tw-h-5 !tw-w-5 !tw-min-h-[20px] !tw-min-w-[20px]"
                    >info</mat-icon
                >
                <span
                    *ngIf="form.get('email')?.errors?.['required']"
                    class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
                >
                    {{ translations[selectedLanguage].error.required.email }}
                </span>
                <span
                    *ngIf="form.get('email')?.errors?.['email'] || form.get('email')?.errors?.['invalidEmail'] || form.get('email')?.errors?.['maxlength']"
                    class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
                >
                    {{ translations[selectedLanguage].error.pattern.email }}
                </span>
            </div>
        </div>

        <!-- Company -->
        <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-mb-1">
                {{ translations[selectedLanguage].company }}
                <span class="tw-text-red-500">*</span>
            </label>
            <input
                type="text"
                formControlName="company"
                class="tw-w-full tw-border tw-rounded-lg tw-px-3 tw-py-2 focus:tw-ring-1 focus:tw-ring-gray-600 focus:tw-outline-none"
                [placeholder]="translations[selectedLanguage].company"
            />
            <!-- Validation Errors(company) -->
            <div
                class="error tw-flex tw-items-start tw-mt-1"
                *ngIf="
                    form.get('company')?.touched && form.get('company')?.invalid
                "
            >
                <mat-icon
                    fontSet="material-icons-outlined"
                    class="tw-text-red-500 tw-text-sm error-icon !tw-h-5 !tw-w-5 !tw-min-h-[20px] !tw-min-w-[20px]"
                    >info</mat-icon
                >
                <span
                    *ngIf="form.get('company')?.errors?.['required']"
                    class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
                >
                    {{ translations[selectedLanguage].error.required.company }}
                </span>
                <span
                    *ngIf="form.get('company')?.errors?.['pattern'] || form.get('company')?.errors?.['minlength'] || form.get('company')?.errors?.['maxlength']"
                    class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
                >
                    {{ translations[selectedLanguage].error.pattern.company }}
                </span>
            </div>
        </div>

        <!-- Industry -->
        <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-mb-2">
                {{ translations[selectedLanguage].industry }}
                <span class="tw-text-red-500">*</span>
            </label>
            <div class="tw-space-y-2">
                <label class="tw-flex tw-items-center tw-space-x-2 tw-w-fit">
                    <input
                        class="tw-accent-[#024B3F]"
                        type="radio"
                        formControlName="industry"
                        value="Services"
                    />
                    <span>{{
                        translations[selectedLanguage].industries.services
                    }}</span>
                </label>
                <label class="tw-flex tw-items-center tw-space-x-2 tw-w-fit">
                    <input
                        class="tw-accent-[#024B3F]"
                        type="radio"
                        formControlName="industry"
                        value="Manufacturing"
                    />
                    <span>{{
                        translations[selectedLanguage].industries.manufacturing
                    }}</span>
                </label>
                <label class="tw-flex tw-items-center tw-space-x-2 tw-w-fit">
                    <input
                        class="tw-accent-[#024B3F]"
                        type="radio"
                        formControlName="industry"
                        value="Agriculture"
                    />
                    <span>{{
                        translations[selectedLanguage].industries.agriculture
                    }}</span>
                </label>
                <label class="tw-flex tw-items-center tw-space-x-2 tw-w-fit">
                    <input
                        class="tw-accent-[#024B3F]"
                        type="radio"
                        formControlName="industry"
                        value="Mining and Quarrying"
                    />
                    <span>{{
                        translations[selectedLanguage].industries.mining
                    }}</span>
                </label>
                <label class="tw-flex tw-items-center tw-space-x-2 tw-w-fit">
                    <input
                        class="tw-accent-[#024B3F]"
                        type="radio"
                        formControlName="industry"
                        value="Construction"
                    />
                    <span>{{
                        translations[selectedLanguage].industries.construction
                    }}</span>
                </label>
            </div>
            <!-- Validation Errors(industry) -->
            <div
                class="error tw-flex tw-items-start tw-mt-1"
                *ngIf="
                    form.get('industry')?.touched &&
                    form.get('industry')?.invalid
                "
            >
                <mat-icon
                    fontSet="material-icons-outlined"
                    class="tw-text-red-500 tw-text-sm error-icon !tw-h-5 !tw-w-5 !tw-min-h-[20px] !tw-min-w-[20px]"
                    >info</mat-icon
                >
                <span
                    *ngIf="form.get('industry')?.errors?.['required']"
                    class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
                >
                    {{ translations[selectedLanguage].error.required.industry }}
                </span>
            </div>
        </div>

        <!-- Feedback -->
        <div>
            <label class="tw-block tw-text-sm tw-font-medium tw-mb-1">
                {{ translations[selectedLanguage].feedback }}
                <span class="tw-text-red-500">*</span>
            </label>
            <textarea
                formControlName="feedback"
                class="tw-w-full tw-border tw-rounded-lg tw-px-3 tw-py-2 tw-h-24 focus:tw-ring-1 focus:tw-ring-gray-600 focus:tw-outline-none"
                [placeholder]="
                    translations[selectedLanguage].feedbackPlaceholder
                "
            >
            </textarea>
            <!-- Validation Errors(feedback) -->
            <div
                class="error tw-flex tw-items-start tw-mt-1"
                *ngIf="
                    form.get('feedback')?.touched &&
                    form.get('feedback')?.invalid
                "
            >
                <mat-icon
                    fontSet="material-icons-outlined"
                    class="tw-text-red-500 tw-text-sm error-icon !tw-h-5 !tw-w-5 !tw-min-h-[20px] !tw-min-w-[20px]"
                    >info</mat-icon
                >
                <span
                    *ngIf="form.get('feedback')?.errors?.['required']"
                    class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
                >
                    {{ translations[selectedLanguage].error.required.feedback }}
                </span>
                <span
                    *ngIf="form.get('feedback')?.errors?.['pattern'] || form.get('feedback')?.errors?.['minlength'] || form.get('feedback')?.errors?.['maxlength']"
                    class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
                >
                    {{ translations[selectedLanguage].error.pattern.feedback }}
                </span>
            </div>
        </div>

        <!-- Consent -->
        <div class="tw-flex tw-items-start tw-space-x-2">
            <input
                type="checkbox"
                formControlName="termsConditions"
                class="tw-mt-[5px] tw-accent-[#024B3F]"
            />
            <p class="tw-text-sm !tw-mb-0">
                {{ translations[selectedLanguage].consent }}
                <a
                    href="/assets/documents/Privacy & Security Policies.pdf"
                    target="_blank"
                    class="tw-underline"
                    >{{ translations[selectedLanguage].privacy }}</a
                >
                {{ selectedLanguage === "en" ? "and" : "dan" }}
                <a
                    href="/assets/documents/Terms of Use (EN).pdf"
                    target="_blank"
                    class="tw-underline"
                    >{{ translations[selectedLanguage].termsConditions }}</a
                >.<span class="tw-text-red-500">*</span>
            </p>
        </div>
        <!-- Validation Errors(termsConditions) -->
        <div
            class="error tw-flex tw-items-start !tw-m-0"
            *ngIf="
                form.get('termsConditions')?.touched &&
                form.get('termsConditions')?.invalid
            "
        >
            <mat-icon
                fontSet="material-icons-outlined"
                class="tw-text-red-500 tw-text-sm error-icon !tw-h-5 !tw-w-5 !tw-min-h-[20px] !tw-min-w-[20px]"
                >info</mat-icon
            >
            <span
                *ngIf="form.get('termsConditions')?.errors?.['required']"
                class="tw-text-red-500 tw-text-xs tw-mt-[1.5px]"
            >
                {{
                    translations[selectedLanguage].error.required
                        .termsConditions
                }}
            </span>
        </div>

        <!-- Submit -->
        <div class="tw-flex tw-justify-start">
            <button
                [disabled]="isLoading"
                type="submit"
                [ngClass]="form.invalid ? 'tw-bg-gray-500' : 'tw-bg-[#024B3F]'"
                class="tw-text-white tw-px-6 tw-py-3 tw-rounded-full"
            >
                {{ translations[selectedLanguage].submit }}
            </button>
        </div>
    </form>
</div>
